import { fetchAuthSession } from "aws-amplify/auth";
import * as SentryReact from "@sentry/react";

let cachedSession: Awaited<ReturnType<typeof fetchAuthSession>> | null = null;
let cacheTimestamp = 0;
let inflightPromise: Promise<
	Awaited<ReturnType<typeof fetchAuthSession>>
> | null = null;

const CACHE_TTL_MS = 5_000;

// Serves to prevent TooManyRequestsException
// https://village-caregiving-llc.sentry.io/issues/7404453012/events/360a7a05e9514111b4e4dfc887774872/
export async function rateLimitedFetchAuthSession(opts?: {
	skipCache?: boolean;
}) {
	const now = Date.now();

	if (
		!opts?.skipCache &&
		cachedSession &&
		now - cacheTimestamp < CACHE_TTL_MS
	) {
		return cachedSession;
	}

	if (inflightPromise) {
		return inflightPromise;
	}

	inflightPromise = fetchAuthSession()
		.then((session) => {
			if (!session.tokens?.accessToken) {
				SentryReact.logger.warn(
					"fetchAuthSession: session returned without access token",
				);
				// Do not cache sessions without tokens - this can happen transiently during
				// token refresh races across tabs. Caching it would cause all API calls in the
				// TTL window to fail and potentially trigger unnecessary sign-outs.
			} else {
				cachedSession = session;
				cacheTimestamp = Date.now();
			}
			inflightPromise = null;
			return session;
		})
		.catch((err) => {
			SentryReact.logger.error(
				`fetchAuthSession: failed - ${err instanceof Error ? err.message : "unknown error"}`,
			);
			inflightPromise = null;
			throw err;
		});

	return inflightPromise;
}
